<template>
  <div class="position_relative">
    <div class="padding_content" id="padding_payment" style="padding-bottom: 110px;">
      <div id="payment_container">
        <div class="payment_content">
          <img
            src="../assets/img/search-malware.png"
            alt=""
            class="bg_malware"
            v-if="this.$route.query.service === 'Mobile Malware Detection Service'"
          />
          <img
            src="../assets/img/search-url.png"
            alt=""
            class="bg_malware"
            v-if="this.$route.query.service === 'URL Filtering Service'"
          />
          <img
            src="../assets/img/search-appinsight.png"
            alt=""
            class="bg_malware"
            v-if="this.$route.query.service === 'Android Dynamic & Static Analysis Report'"
          />
          <div class="content_top">
            <h2 class="title" v-if="lang === 'en'">{{ this.$route.query.service }}</h2>
            <h2 class="title" v-if="lang === 'zh'">
              {{ formatChinese(this.$route.query.service) }}
            </h2>
            <div class="price">
              <span class="newprice"
                >${{ this.$route.query.discountPrice || this.$route.query.originalPrice }}</span
              >
              <span class="way" v-if="lang === 'en'">{{ this.$route.query.type }}</span>
              <span class="way" v-if="lang === 'zh'">{{ formatType(this.$route.query.type) }}</span>
            </div>
            <div
              class="description"
              v-for="(item, index) in this.$route.query.description"
              :key="index"
            >
              <span v-if="index == 0">{{ item }}</span>
            </div>
          </div>
          <div class="content_container">
            <h2 class="title">{{ $t('payment.pay') }}</h2>
            <el-steps :active="active" finish-status="success" style="margin: 27px 0;">
              <el-step :title="$t('payment.payType')"></el-step>
              <el-step :title="$t('payment.result')"></el-step>
            </el-steps>
            <div v-if="active === 0">
              <p class="card_information">{{ $t('payment.enterInformation') }}</p>
              <div class="payways" v-if="cardList.length === 0">
                <span><img src="../assets/img/icon-visa.png" alt=""/></span>
                <span><img src="../assets/img/icon-master.png" alt=""/></span>
              </div>
              <div v-if="cardList.length > 0">
                <div v-for="(item, index) in cardList" :key="index">
                  <div class="payways">
                    <span v-if="item.brand == 'Visa'"
                      ><img src="../assets/img/icon-visa.png" alt=""
                    /></span>
                    <span v-if="item.brand !== 'Visa'"
                      ><img src="../assets/img/icon-visa.png" alt=""
                    /></span>
                  </div>
                  <ul class="msg_ul">
                    <li class="msg_li">
                      <span>{{ $t('user.Name') }}</span>
                      <span>{{ item.name }}</span>
                    </li>
                    <li class="msg_li">
                      <span>{{ $t('user.CardNumber') }}</span>
                      <span>**** **** **** {{ item.last4 }}</span>
                    </li>
                    <li class="msg_li">
                      <span>{{ $t('user.ExpirationDate') }}</span>
                      <span>{{ format(item.expMonth) }} / {{ item.expYear }}</span>
                    </li>
                    <div class="btn_submit" @click="next()">{{ $t('message.confirm') }}</div>
                  </ul>
                </div>
              </div>
              <el-form
                ref="sizeForm"
                :model="sizeForm"
                :rules="rules"
                size="mini"
                v-if="cardList.length === 0"
              >
                <el-form-item :label="$t('user.Name')" prop="name">
                  <el-input v-model="sizeForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <div class="card">
                  <el-form-item :label="$t('user.CardNumber')" class="card_num" prop="cardNumber">
                    <el-input
                      v-model="sizeForm.cardNumber"
                      autocomplete="off"
                      type="number"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('user.CVV')" class="card_cvv" prop="cvv">
                    <el-input
                      v-model="sizeForm.cvv"
                      autocomplete="new-password"
                      type="password"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="Expiration date" class="el-item-date" prop="date">
                  <el-select v-model="sizeForm.month" class="date-month" filterable>
                    <el-option
                      v-for="item in month_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-date-picker
                    type="year"
                    placeholder="2019"
                    v-model="sizeForm.year"
                    class="date-year"
                    prefix-icon="el-icon-arrow-down"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item size="large">
                  <div class="btn_submit" @click="submitForm('sizeForm')">
                    {{ $t('message.confirm') }}
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <waiting :show="active === 1" :message="msg"></waiting>
            <div v-if="active === 2">
              <div class="success">
                <i class="el-icon-success"></i>
                <div>
                  <p>{{ $t('payment.paySuccessfully') }}</p>
                  <p>{{ $t('payment.payTip1') }}</p>
                  <p>{{ $t('payment.payTip2') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading :show="loadingStatus"></loading>
    <Footer></Footer>
  </div>
</template>
<script>
import axios from 'axios'
import loading from '@/components/loading'
import waiting from '@/components/waiting'
import { Message } from 'element-ui'
import { common } from '@/views/public/common'
import Footer from '@/components/footer'
import { downAPP } from './public/validator'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'Payment',
  components: { loading, waiting, Footer },
  data() {
    var validateCardNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('errMsg.cardNumberErr1')))
      }
      if (value) {
        setTimeout(() => {
          var reg = /^[4|5|6]\d{12,15}$/
          var reg2 = /^[3][7]\d{11,14}$/
          if (!reg.test(value) && !reg2.test(value)) {
            callback(new Error(this.$t('errMsg.cardNumberErr2')))
          } else {
            callback()
          }
        }, 500)
      }
    }
    var validateCVV = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('errMsg.cvvErr1')))
      }
      if (value) {
        setTimeout(() => {
          var reg = /^\d{3,4}$/
          if (!reg.test(value)) {
            callback(new Error(this.$t('errMsg.cvvErr2')))
          } else {
            callback()
          }
        }, 500)
      }
    }
    return {
      planId: this.$route.query.planId || '',
      active: 0,
      loadingStatus: true,
      cardList: [],
      sizeForm: {
        name: '',
        cardNumber: '',
        cvv: '',
        year: '2019',
        month: 1
      },
      month_options: [
        {
          value: 1,
          label: 1
        },
        {
          value: 2,
          label: 2
        },
        {
          value: 3,
          label: 3
        },
        {
          value: 4,
          label: 4
        },
        {
          value: 5,
          label: 5
        },
        {
          value: 6,
          label: 6
        },
        {
          value: 7,
          label: 7
        },
        {
          value: 8,
          label: 8
        },
        {
          value: 9,
          label: 9
        },
        {
          value: 10,
          label: 10
        },
        {
          value: 11,
          label: 11
        },
        {
          value: 12,
          label: 12
        }
      ],
      options: [
        {
          value: '选项1',
          label: '中国'
        },
        {
          value: '选项2',
          label: '美国'
        },
        {
          value: '选项3',
          label: '日本'
        },
        {
          value: '选项4',
          label: '韩国'
        },
        {
          value: '选项5',
          label: '朝鲜'
        }
      ],
      rules: {
        name: [{ required: true, message: this.$t('errMsg.cardNameErr'), trigger: 'blur' }],
        cardNumber: [{ validator: validateCardNumber, trigger: ['blur', 'change'] }],
        cvv: [{ validator: validateCVV, trigger: ['blur', 'change'] }],
        year: [
          {
            type: 'date',
            required: true,
            message: this.$t('errMsg.cardYearErr'),
            trigger: 'change'
          }
        ],
        month: [
          {
            type: 'date',
            required: true,
            message: this.$t('errMsg.cardMonthErr'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    getCardList() {
      axios
        .get('/api/payment')
        .then(res => {
          this.loadingStatus = false
          res.data.map(item => {
            if (item.isDefault === true) {
              this.cardList.push(item)
            }
          })
        })
        .catch(err => {
          this.loadingStatus = false
          Message.error(err)
        })
    },
    next() {
      this.active = 1
      let data = {
        planId: this.planId
      }
      axios
        .post('/api/order', data)
        .then(res => {
          this.active = 2
        })
        .catch(err => {
          Message({
            type: 'error',
            message: err.response.data.statusCode + ' ' + err.response.data.message,
            showClose: true
          })
          this.active = 0
          this.sizeForm.year = '2019'
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.active = 1
          if (this.sizeForm.year == new Date().getFullYear()) {
            this.sizeForm.year = Number(this.sizeForm.year.substring(this.sizeForm.year.length - 2))
          } else {
            this.sizeForm.year = this.sizeForm.year.getFullYear() + ''
            this.sizeForm.year = Number(this.sizeForm.year.substring(this.sizeForm.year.length - 2))
          }
          let creditCardInfo = {
            name: this.sizeForm.name,
            number: this.sizeForm.cardNumber,
            expMonth: this.sizeForm.month,
            expYear: this.sizeForm.year,
            cvc: this.sizeForm.cvv
          }
          let data = {
            planId: this.planId,
            creditCardInfo: creditCardInfo
          }
          axios
            .post('/api/order', data)
            .then(res => {
              this.active = 2
              this.$refs[formName].resetFields()
            })
            .catch(err => {
              Message({
                type: 'error',
                message: err.response.data.statusCode + ' ' + err.response.data.message,
                showClose: true
              })
              this.active = 0
              this.sizeForm.year = new Date().getFullYear() + ''
            })
        } else {
          Message({ type: 'error', message: this.$t('errMsg.err1'), showClose: true })
          return false
        }
      })
    },
    jump() {
      this.$router.go(-1).catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    },
    format: common.format,
    formatChinese(serviceName) {
      const services = {
        'Mobile Malware Detection Service': '病毒检测测试',
        'URL Filtering Service': 'URL网址测试',
        'Android Dynamic & Static Analysis Report': '安卓动态与静态分析报告服务'
      }
      return services[serviceName]
    },
    formatType(type) {
      const types = {
        monthly: '/月',
        'One Time Package': '/次'
      }
      return types[type]
    }
  },
  computed: {
    msg() {
      return this.$t('message.processing')
    },
    lang() {
      return this.$store.state.lang
    }
  },
  created() {
    this.sizeForm.month = new Date().getMonth() + 1
    this.sizeForm.year = new Date().getFullYear() + ''
  },
  mounted() {
    this.getCardList()
    downAPP('padding_payment', '200px')
  }
}
</script>

<style lang="scss" scoped>
.msg_ul {
  margin-top: 10px;
  & > li {
    & > span {
      display: block;
      &:first-child {
        box-sizing: border-box;
        height: 32px;
        font-size: 16px;
        color: #545454;
      }
      &:nth-child(2) {
        width: 348px;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.4);
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        text-indent: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
.success {
  @include flex-start;
  margin: 40px 0;
  ::v-deep .el-icon-success {
    color: #5daf34;
    font-size: 25px;
    margin-right: 15px;
  }
  & > div p {
    font-size: 14px;
    margin-bottom: 10px;
    &:first-child {
      font-size: 18px;
      font-weight: 900;
    }
  }
}
::v-deep .el-form-item__label {
  float: none;
  color: rgba(84, 84, 84, 0.6);
  font-size: 16px;
  height: 40px;
  box-sizing: border-box;
  padding-top: 16px;
}
::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: '';
  color: #f56c6c;
  margin-right: 4px;
}
::v-deep .el-input__inner {
  width: 348px;
  height: 40px;
  background-color: #fcfcfc;
  border: 1px solid #c0c0c0;
  @include border-radius(5px);
}
::v-deep .el-input--mini .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-item-date {
  margin-top: 22px;
  height: 66px;
  ::v-deep .el-form-item__label {
    height: 26px;
  }
  ::v-deep .el-input--mini .el-input__inner {
    height: 40px;
    width: 100px;
    margin-right: 11px;
    text-align: center;
    &::-webkit-input-placeholder {
      color: #545454;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      color: #545454;
    }

    &::-moz-placeholder {
      /* Firefox 19+ */
      color: #545454;
    }

    &:-ms-input-placeholder {
      color: #545454;
    }
  }
}
::v-deep .el-select .el-input .el-select__caret {
  position: absolute;
  right: 8px;
  color: #545454;
}
.date-month {
  position: relative;
  ::v-deep .el-icon-arrow-up:before {
    /*content: "\E60C";*/
  }
}
.date-year {
  position: relative;
  ::v-deep .el-input__icon {
    @include absolute-left-bottom(70px, 0);
    color: #545454;
    font-size: 14px;
  }
}
::v-deep .el-step__head.is-success {
  color: $primary-color;
  border-color: $primary-color;
}
::v-deep .el-step__title.is-success {
  color: $primary-color;
}

::v-deep .el-step__head.is-process {
  color: $primary-color;
  border-color: $primary-color;
}

::v-deep .el-step__title.is-process {
  font-weight: 700;
  color: $primary-color;
}

::v-deep .el-form-item {
  margin-bottom: 0;
}

.btn_submit {
  width: 208px;
  height: 52px;
  margin: 36px 0 58px;
  @include border-radius(28px);
  color: $white;
  font-size: 19px;
  background: $primary-color;
  font-weight: 900;
  cursor: pointer;
  text-align: center;
  line-height: 52px;
}

.card {
  width: 348px;
  height: 65px;
  @include flex-space-between;
  margin-top: 18px;
  ::v-deep .el-form-item__label {
    height: 25px;
  }
  .card_num {
    ::v-deep .el-input__inner {
      width: 242px;
    }
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    ::v-deep input[type='number'] {
      -moz-appearance: textfield;
    }
  }
  .card_cvv {
    ::v-deep .el-input__inner {
      width: 94px;
    }
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    ::v-deep input[type='number'] {
      -moz-appearance: textfield;
    }
  }
}
.el-item2 {
  margin-bottom: 19px;
}
.state_code {
  width: 348px;
  @include flex-space-between;
  .state {
    ::v-deep .el-input__inner {
      width: 232px;
    }
  }
  .code {
    ::v-deep .el-input__inner {
      width: 106px;
    }
  }
}
.payment_content {
  background: $white;
  position: relative;
  min-height: 500px;
  margin-bottom: 28px;
  padding-bottom: 10px;
  .bg_malware {
    width: 122px;
    height: 135px;
    @include absolute-left-top(0, 0);
  }
  .chat {
    width: 38px;
    height: 45px;
    @include absolute-right-bottom(-35px, 265px);
  }
  .content_top {
    width: 700px;
    height: 248px;
    padding-left: 47px;
    box-sizing: border-box;
    border-bottom: 1px dashed #979797;
    margin: 0 auto;
    .title {
      padding: 61px 0 35px;
      font-size: 28px;
      color: #545454;
      height: 28px;
    }
    .price {
      margin-bottom: 9px;
      .newprice {
        font-size: 27px;
        color: #333;
        font-weight: 900;
      }
      .way {
        font-size: 12px;
        margin: 0 22px 0 5px;
        color: #545454;
      }
      .oldprice {
        font-size: 21px;
        color: $primary-color;
        text-decoration: line-through;
      }
      .description {
        @include flex-wrap;
        font-size: 12px;
        line-height: 26px;
        color: #333;
      }
    }
  }
  .content_container {
    width: 700px;
    padding-left: 47px;
    padding-right: 20px;
    box-sizing: border-box;
    margin: 0 auto;
    .title {
      padding: 35px 0 25px;
      font-size: 28px;
      color: #545454;
      height: 28px;
    }
    .card_information {
      font-size: 18px;
      color: #1d1d1d;
      margin: 0 0 18px;
    }
    .payways {
      & > span {
        display: inline-block;
        width: 52px;
        height: 33px;
        margin-right: 8px;
        & > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.jump {
  &:hover {
    cursor: pointer;
    color: #ff6500;
  }
}

@media screen and (max-width: 1210px) {
  .payment_content {
    .content_top {
      padding-left: 85px;
    }
    .content_container {
      padding-left: 85px;
    }
  }
}

@media screen and (max-width: 1074px) {
  .payment_content {
    .content_top {
      width: 100%;
      .title {
        padding: 61px 0 20px;
        height: auto;
      }
    }
    .content_container {
      width: 100%;
    }
  }
}
@media screen and (max-width: 450px) {
  ::v-deep .el-steps {
    margin-top: 0 !important;
  }
  ::v-deep .el-form {
    width: 100%;
    height: auto;
  }

  ::v-deep .el-form-item__label {
    float: none;
    color: rgba(84, 84, 84, 0.6);
    font-size: 16px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 16px;
  }
  ::v-deep .el-input__inner {
    width: 100%;
  }
  .card {
    width: 100%;
    height: auto;
    display: block;
    ::v-deep .el-form-item__label {
      float: none;
      color: rgba(84, 84, 84, 0.6);
      font-size: 16px;
      height: 40px;
      box-sizing: border-box;
      padding-top: 16px;
    }
    .card_num,
    .card_cvv {
      ::v-deep .el-input__inner {
        width: 100%;
      }
    }
  }
  ::v-deep .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 60px;
  }
  .date-month {
    margin-bottom: 10px;
  }
  .btn_submit {
    width: 100%;
    margin: 36px 0 20px;
  }
  .payment_content {
    .bg_malware {
      width: 60px;
      height: 60px;
    }
    .content_top {
      width: 100%;
      height: 220px;
      padding: 0 24px;
      .title {
        padding: 61px 0 24px;
        font-size: 16px;
      }
      .price {
        .newprice {
          font-size: 18px;
        }
      }
    }
    .content_container {
      width: 100%;
      padding: 0 24px;
      .title {
        font-size: 16px;
      }
    }
    .line {
      width: 100%;
      box-sizing: border-box;
    }
  }
  .msg_ul {
    padding-bottom: 20px;
    & > li {
      & > span {
        &:nth-child(2) {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payment.vue